/**
 * Base URL for Product API calls made from the add-in's browser code.
 *
 * Empty on purpose (US28491): every call is same-origin — `/api/...` on the
 * add-in host — and server.mjs relays it to the API (see ../../relay.mjs).
 * The API hostname therefore never reaches the bundle, which is what lets
 * the API stop accepting internet traffic (ADO 28185 / 28383).
 *
 * Local dev: vite.config.ts proxies `/api` to the local API (`ApiUrlBase`,
 * default https://localhost:7222), so the same relative URLs work under
 * `npm run dev`. Tests see relative URLs too.
 */
export const API_BASE_URL = "";
